import React from 'react'
import {Grid, Row, Col} from 'react-bootstrap'
import HorseFinder from '../Ad/HorseFinder'
import {connect} from 'react-redux'
import HorsePhotos from '../NewHorse/HorsePhotos'

import './Layout/AddHorsePhoto.css'

class AddHorsePhotoScreen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      horse: null
    }
    this.resultHandler = this.resultHandler.bind(this)
  }

  resultHandler (result) {
    this.setState({horse: null}, nextProps => {
      this.setState({horse: result})
    })
  }

  render () {
    const {auth} = this.props
    const {horse} = this.state
    return (
      <Grid className="add-horse-photo">
        <Row>
          <Col className="horse-find-box" lg={horse ? 5 : 6} lgOffset={horse ? 0 : 3} md={6} mdOffset={horse ? 0 : 3} sm={horse ? 10 : 8} smOffset={horse ? 1 : 2} xs={12} xsOffset={0}>
            <p>برای شروع نام اسب مورد نظر را در کادر زیر وارد نمایید.</p>
            <HorseFinder resultHandler={this.resultHandler} placeholder="نام اسب" />
          </Col>
          {horse && <Col lg={5} lgOffset={0} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
            <p>در این قسمت می‌توانید عکس های موجود اسب را مشاهده کنید و عکس جدید را برای اضافه شدن قرار دهید.</p>
            <div className="HorseInfo">
              <HorsePhotos photos={horse.photos} horse={horse} auth={auth} />
            </div>
          </Col>}
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(AddHorsePhotoScreen)



// WEBPACK FOOTER //
// ./src/components/AddHorsePhoto/AddHorsePhotoScreen.js